module.exports = __webpack_public_path__ + "static/img/A16.50ef9bef.jpg";